// extracted by mini-css-extract-plugin
export var container = "_kk-0";
export var dotAnimation = "_kk-2";
export var dotsLoading = "_kk-1";